import * as Yup from "yup";
import createLocalizationsSchema from "../Localizations/createLocalizationsSchema";

const ProductSchema = (localeCodes) =>
  Yup.object().shape({
    code: Yup.string().label("ID").required().max(50),
    product_class_id: Yup.string().label("Product Class").required().max(50),
    localizations: createLocalizationsSchema(localeCodes),
  });

export default ProductSchema;
